
import type { TimeZonesIntr, RefreshTime, ConvertTimePayload, ConvertedTime, CustomerProjectEnv, GetProjectsIntr } from "@/shared/types/common.types";
import api from "./apiClient";
export const commonService = {
	GetTimeZones: (): Promise<TimeZonesIntr[]> => api.get("Utilities/GetTimezones").then((res) => res.data),
	GetLastRefreshedTime: (jobName: string, tz: string, options?: { signal?: AbortSignal }): Promise<RefreshTime> => api.get(`Utilities/GetLastRefreshedTime?JobName=${jobName}&timeZone=${tz}`, { signal: options?.signal }).then((res) => res.data),
GetConvertedTime: (Payload:ConvertTimePayload): Promise<ConvertedTime> => api.post("Utilities/ConvertTimeFromBase",Payload).then((res) => res.data),
   GetCustomersProjectEnv: (): Promise<CustomerProjectEnv[]> =>api.get("Customers/GetProjectEnvCustomer").then((res) => res.data),
     GetProjects: (): Promise<GetProjectsIntr[]> =>api.get("Utilities/GetProjects").then((res) => res.data),
   
	
};
